import { BlogsReviewerPath } from 'app-constants';
import { StoreType } from '../redux/store';
import { convertModuleWithStore } from './routes.helper';

export const getReviewerRoutes = (store: StoreType) => ({
  path: `/${BlogsReviewerPath}/:page?`,
  lazy: async () => convertModuleWithStore(await import('./blogs-reviewer/root'), store),
  children:
    [
      {
        path: "view/posts/*",
        lazy: async () => convertModuleWithStore(await import('./blogs-reviewer/view.posts.splat'), store),
      },
      {
        path: "view/meta/*",
        lazy: async () => convertModuleWithStore(await import('./blogs-reviewer/view.meta.splat'), store),
      },
      {
        path: "view/json/*",
        lazy: async () => convertModuleWithStore(await import('./blogs-reviewer/view.json.splat'), store),
      },
      {
        path: "view/:editorType/*",
        lazy: async () => convertModuleWithStore(await import('./blogs-reviewer/view.editorType.splat'), store),
      },
      {
        index: true,
        lazy: async () => convertModuleWithStore(await import('./blogs-reviewer/_index'), store),
      }
    ]
});